/**
 * Create a page for all wpPost nodes automatically via
 * filesystem routing: https://www.gatsbyjs.com/docs/reference/routing/file-system-route-api/
 */
import * as React from "react"
import WordpressContent from "../components/wordpress-content"
import { IYoastBreadcrumb } from "../components/breadcrumbs"

interface IPostProps {
  data: {
    wpPost: Queries.PostContentQuery
  }
  pageContext: {
    id: string
    slugs: Array<string>
    breadcrumbs: Array<IYoastBreadcrumb>
  }
}

export default function FullWidthPost(props: IPostProps): JSX.Element {
  const post = props.data.wpPost

  const html =
    post?.content?.replace(
      /href="https:\/\/(www.georgiancollege.ca|www.gcblueprint.local|georgiangatsby.wpengine.com)\//gim,
      `href="/`
    ) || ``

  return (
    <div className="lg:flex gap-8">
      <div className="w-full">
        <WordpressContent html={html} />
      </div>
    </div>
  )
}
